import React from 'react';
import Menu from '../../../components/Menu/Navbar'
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'
import {ContainerGeneral, ElementoLista, Titulo, Lista, ContainerTexto} from '../../RioGrande/styletexto';
import FxView from '../../../components/FxView/fxview'
import FxImagenBackGround from '../../../components/FxImagenBackGround/fximagenbackground'

import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons';   

const CircuitoInterno = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView/>

      <FxImagenBackGround icon={faBirthdayCake}/>

      <ContainerGeneral>
        <ContainerTexto>

          <Titulo>CUMPLEAÑOS </Titulo>

          <Lista>
            <ElementoLista>
              <strong>En Bellavista Huelva Club</strong>, brindamos servicios de cumpleaños deportivos, consulta a nuestros profesionales y te darán información detallada al respecto.
            </ElementoLista> 
          </Lista>

 

        {/* 👇 IMÁGENES EN COLUMNA */}
<div
  style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '25px',
    marginTop: '40px'
  }}
>
  <img
    src="/cumple1.jpg"
    alt="cumple1"
    style={{
      width: '1000px',
      maxWidth: '100%',
      borderRadius: '12px',
      objectFit: 'cover'
    }}
  />
  <img
    src="/cumple2.jpg"
    alt="cumple2"
    style={{
      width: '1000px',
      maxWidth: '100%',
      borderRadius: '12px',
      objectFit: 'cover'
    }}
  />
  <img
    src="/cumple3.jpg"
    alt="cumple3"
    style={{
       width: '1000px',
      maxWidth: '100%',
      borderRadius: '12px',
      objectFit: 'cover'
    }}
  />
</div>

        </ContainerTexto>
      </ContainerGeneral>

      <Footer />
      <></>
    </div>
  )
}

export default CircuitoInterno